// // server.js
// const express = require('express');
// const fetch = require('node-fetch');
// const app = express();
// const PORT = process.env.PORT || 3000;

// app.get('/api/news', async (req, res) => {
//   try {
//     const response = await fetch('https://ellen-branding-labo.com/article/wp-json/wp/v2/posts');
//     const data = await response.json();
//     res.json(data);
//   } catch (error) {
//     console.error('データの取得に失敗しました:', error);
//     res.status(500).json({ error: 'データの取得に失敗しました' });
//   }
// });

// app.listen(PORT, () => {
//   console.log(`Server is running on port ${PORT}`);
// });